import { Button, Card, Flex, Popconfirm, Tag, Typography } from 'antd';
import { useLiveQuery } from 'dexie-react-hooks';
import { useTranslation } from 'translations/hooks';

import { useBoardContext } from 'business/quality-control/pages/record-segment-defect/context/board-context';
import { useUploadQualityData } from 'business/quality-control/pages/record-segment-defect/hooks/use-upload-quality-data';
import { utilsDbService } from 'technical/db/db.service';
import { useNetworkStatus } from 'technical/network/use-network-status';
import { NoConnexion } from 'ui/icons/no-connexion';

export const SessionHeader = () => {
  const { t } = useTranslation();

  const { isOnline } = useNetworkStatus();
  const { upload, isUploading } = useUploadQualityData();
  const { setBoardConstructionSiteId } = useBoardContext();

  const unsavedCount = useLiveQuery(
    () => utilsDbService.isWaitingSynchronisation(),
    [],
  );

  const handleExit = async () => {
    await utilsDbService.resetData();
    setBoardConstructionSiteId(undefined);
  };

  return (
    <Card>
      <Flex justify="space-between" align="center">
        <Flex vertical gap={8} align="start">
          {unsavedCount ? (
            <Tag
              style={{
                color: '#FFFFFF',
                borderColor: '#FF6E6E',
                backgroundColor: '#FF6E6E',
                borderRadius: 10,
              }}
            >
              {t(
                'qualityControl.recordSegmentDefect.leftPanel.header.nbUnsavedItems',
                {
                  count: unsavedCount,
                },
              )}
            </Tag>
          ) : (
            <Typography.Text>
              {t(
                'qualityControl.recordSegmentDefect.leftPanel.header.emptyMessage',
              )}
            </Typography.Text>
          )}
        </Flex>

        <Flex gap={32}>
          <Popconfirm
            title={t(
              'qualityControl.recordSegmentDefect.leftPanel.header.resetDataWarning',
            )}
            placement="topRight"
            onConfirm={handleExit}
          >
            <Button loading={isUploading}>
              {t(
                'qualityControl.recordSegmentDefect.leftPanel.header.cta.exit',
              )}
            </Button>
          </Popconfirm>

          <Button
            type="primary"
            icon={!isOnline ? <NoConnexion /> : null}
            onClick={async () => {
              await upload();
            }}
            loading={isUploading}
            disabled={!isOnline}
          >
            {t('qualityControl.recordSegmentDefect.leftPanel.header.cta.save')}
          </Button>
        </Flex>
      </Flex>
    </Card>
  );
};
